module.exports = __webpack_public_path__ + "static/img/bianmin.8e74314.png";


//////////////////
// WEBPACK FOOTER
// ./static/bianmin.png
// module id = VnTI
// module chunks = 1